/* Sunday Citizen — Landing Page behaviour (shared).
   Reveals the sticky bottom conversion bar once the hero has scrolled out. */
(function () {
  function init() {
    var bar = document.querySelector('[data-lp-stickybar]');
    if (!bar) return;
    var hero = document.querySelector('[data-lp-hero]') || document.querySelector('.lp-hero');

    function toggle(show) {
      bar.classList.toggle('is-visible', show);
      document.body.classList.toggle('lp-bar-visible', show);
    }

    if (hero && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          // visible once the hero is no longer intersecting the viewport
          toggle(!entry.isIntersecting);
        });
      }, { threshold: 0, rootMargin: '0px 0px -10% 0px' });
      io.observe(hero);
    } else {
      toggle(true);
    }
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
